module.exports = __webpack_public_path__ + "img/chow_colour.0a26a81c.webp";